'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_subscription_error',
    viewClass: require('./view'),

    methods: {
        renderTemplate(toDelete) {
            this.renderTemplate(toDelete);
        },
    },
});
